module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.step === 1) ? _c('section', {
    staticClass: "content cleafix"
  }, [_c('form', [_c('h1', {
    staticClass: "form-head"
  }, [_vm._v("\n        用户注册\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "form-body"
  }, [_c('div', {
    staticClass: "input-item clearfix p-t-xs"
  }, [_c('div', {
    staticClass: "col-xs-6 n-p-l"
  }, [_c('div', {
    staticClass: "col-xs-12 inline-block btn btn-md text-center",
    class: {
      'btn-primary': _vm.category === 1
    },
    on: {
      "click": function($event) {
        _vm.category = 1
      }
    }
  }, [_vm._v("普通用户注册")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 n-p-r"
  }, [_c('div', {
    staticClass: "col-xs-12 inline-block btn btn-md text-center right",
    class: {
      'btn-primary': _vm.category === 2
    },
    on: {
      "click": function($event) {
        _vm.category = 2
      }
    }
  }, [_vm._v("校企用户注册")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.category === 1),
      expression: "category === 1"
    }],
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.nickname),
      expression: "nickname",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "nickname",
      "placeholder": "昵称：风清扬",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.nickname)
    },
    on: {
      "blur": [function($event) {
        _vm.checkUserNickname()
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nickname = $event.target.value.trim()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.nickname))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.category === 2),
      expression: "category === 2"
    }],
    staticClass: "input-item clearfix p-t-xs"
  }, [_c('span', {
    staticClass: "lab"
  }, [_vm._v("类型：")]), _vm._v(" "), _c('label', {
    staticClass: "m-r-sm",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "for": "category-company"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ccategory),
      expression: "ccategory",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "m-r-xs",
    attrs: {
      "type": "radio",
      "value": "1",
      "id": "category-company"
    },
    domProps: {
      "checked": _vm._q(_vm.ccategory, _vm._n("1"))
    },
    on: {
      "__c": function($event) {
        _vm.ccategory = _vm._n("1")
      }
    }
  }), _vm._v("公司\n          ")]), _vm._v(" "), _c('label', {
    staticClass: "m-r-sm",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "for": "category-school"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ccategory),
      expression: "ccategory",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "m-r-xs",
    attrs: {
      "type": "radio",
      "value": "2",
      "id": "category-school"
    },
    domProps: {
      "checked": _vm._q(_vm.ccategory, _vm._n("2"))
    },
    on: {
      "__c": function($event) {
        _vm.ccategory = _vm._n("2")
      }
    }
  }), _vm._v("学校\n          ")])]), _vm._v(" "), (_vm.category === 2 && _vm.ccategory === 1) ? _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.companyName),
      expression: "companyName",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "companyName",
      "placeholder": "公司名称：XX公司",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.companyName)
    },
    on: {
      "blur": [function($event) {
        _vm.checkCompanyName()
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyName = $event.target.value.trim()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.companyName))])]) : _vm._e(), _vm._v(" "), (_vm.category === 2 && _vm.ccategory === 2) ? _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.companyName),
      expression: "companyName",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "companyName",
      "placeholder": "学校名称：XX大学",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.companyName)
    },
    on: {
      "blur": [function($event) {
        _vm.checkCompanyName()
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyName = $event.target.value.trim()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.companyName))])]) : _vm._e(), _vm._v(" "), (_vm.category === 2 && _vm.ccategory === 1) ? _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.username),
      expression: "username",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "企业邮箱：service@lechenggu.com",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "blur": [function($event) {
        _vm.checkEmail()
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value.trim()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.username))])]) : _vm._e(), _vm._v(" "), (_vm.category === 2 && _vm.ccategory === 2) ? _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.username),
      expression: "username",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "学校邮箱：service@lechenggu.com",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "blur": [function($event) {
        _vm.checkEmail()
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value.trim()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.username))])]) : _vm._e(), _vm._v(" "), (_vm.category === 1) ? _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.username),
      expression: "username",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "用户名：邮箱或手机号",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "blur": [function($event) {
        _vm.checkUsername()
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value.trim()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.username))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-item clearfix"
  }, [_c('div', {
    staticClass: "col-xs-12 clearfix"
  }, [_c('div', {
    staticClass: "row clearfix"
  }, [_c('div', {
    staticClass: "col-sm-7 n-p-l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.verifyCode),
      expression: "verifyCode",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "验证码：6位"
    },
    domProps: {
      "value": (_vm.verifyCode)
    },
    on: {
      "blur": [function($event) {
        _vm.validateCode()
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifyCode = $event.target.value.trim()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5 n-p-r n-p-l"
  }, [_c('button', {
    staticClass: "btn btn-md btn-primary col-xs-12",
    attrs: {
      "type": "button",
      "disabled": _vm.reset.disabled
    },
    on: {
      "click": function($event) {
        _vm.sendVerifyCode()
      }
    }
  }, [_vm._v(_vm._s(_vm.reset.text))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.code))])])])]), _vm._v(" "), _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "密码：6-16位字符、数字、特殊字符",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.rpassword),
      expression: "rpassword",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "name": "rpassword",
      "placeholder": "再次输入：6-16位字符、数字、特殊字符",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.rpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rpassword = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.password))])]), _vm._v(" "), _c('div', {
    staticClass: "input-item clearfix"
  }, [_c('button', {
    staticClass: "btn btn-md btn-primary col-xs-12",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        _vm.registerFunc()
      }
    }
  }, [_vm._v("注    册")])]), _vm._v(" "), _c('div', {
    staticClass: "input-item"
  }, [_c('h5', {
    staticClass: "reg_now"
  }, [_vm._v("已有帐号？\n            "), _c('router-link', {
    staticClass: "color-primary ",
    attrs: {
      "to": {
        name: '/auth/login',
        params: {}
      }
    }
  }, [_vm._v("直接登录")]), _vm._v(" "), _c('router-link', {
    staticClass: "color-primary right",
    attrs: {
      "to": {
        name: '/auth/reset_password',
        params: {}
      }
    }
  }, [_vm._v("忘记密码?")])], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "init-content"
  }, [_c('div', {
    staticClass: "step-content"
  }, [(_vm.category === 1) ? _c('form', {
    staticClass: "company-info"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "input-item n-m-b"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "alt": _vm.user.nickname,
      "src": _vm.user.avatar
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "hidden-file",
    attrs: {
      "type": "file",
      "name": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.uploadAvatar($event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-item show-info text-center"
  }, [_c('span', {
    staticClass: "email"
  }, [_vm._v(_vm._s(_vm.user.nickname))])]), _vm._v(" "), _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.user.realname),
      expression: "user.realname",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "真实姓名：华宇互联",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.user.realname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.realname = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.user.qq),
      expression: "user.qq",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "QQ：10000",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.user.qq)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.qq = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-item"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.user.signature),
      expression: "user.signature",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input textarea",
    attrs: {
      "resize": "none",
      "placeholder": "个性签名：人在江湖飘，就是要挨刀！",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.user.signature)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.signature = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-item"
  }, [_c('button', {
    staticClass: "btn btn-md btn-primary col-xs-12",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.completeInfo()
      }
    }
  }, [_vm._v("完成注册")])])]) : _vm._e(), _vm._v(" "), (_vm.category === 2) ? _c('form', {
    staticClass: "company-info"
  }, [_c('h1', {
    staticClass: "form-head"
  }, [_c('i', {
    staticClass: "step"
  }, [_vm._v("2.")]), _vm._v(" 完善" + _vm._s(_vm.ccategory === 1 ? '公司' : '学校') + "信息")]), _vm._v(" "), _c('div', {
    staticClass: "input-item"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "alt": _vm.company.name,
      "src": _vm.company.logo
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "hidden-file",
    attrs: {
      "type": "file",
      "name": "file"
    },
    on: {
      "change": function($event) {
        _vm.uploadLogo(_vm.event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-item show-info text-center"
  }, [_c('span', {
    staticClass: "email"
  }, [_vm._v(_vm._s(_vm.companyName))])]), _vm._v(" "), (_vm.ccategory === 1) ? _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.company.short_name),
      expression: "company.short_name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "公司简称，比如：华宇互联",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.company.short_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.company.short_name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.ccategory === 2) ? _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.company.short_name),
      expression: "company.short_name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "学校简称，比如：华宇互联",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.company.short_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.company.short_name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.ccategory === 1) ? _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.company.credit_code),
      expression: "company.credit_code",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "信用代码，比如：918888888888888888",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.company.credit_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.company.credit_code = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.company.principal.name),
      expression: "company.principal.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "常用联系人，比如：王小帅",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.company.principal.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.company.principal.name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.company.principal.phone),
      expression: "company.principal.phone",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "联系人电话，比如：1888888888",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.company.principal.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.company.principal.phone = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-item"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 n-p-l"
  }, [_c('input', {
    staticClass: "btn btn-md btn-primary col-xs-12",
    attrs: {
      "type": "button",
      "value": "跳过，直接使用"
    },
    on: {
      "click": function($event) {
        _vm.skipComplete()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 n-p-r"
  }, [_c('input', {
    staticClass: "btn btn-md btn-primary col-xs-12",
    attrs: {
      "type": "button",
      "value": "完成注册"
    },
    on: {
      "click": function($event) {
        _vm.completeInfo()
      }
    }
  })])])])])]) : _vm._e()])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "form-head"
  }, [_c('i', {
    staticClass: "step"
  }, [_vm._v("2.")]), _vm._v(" 完善个人信息")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "split"
  }, [_c('div', {
    staticClass: "b-b b-dashed m-b-xs"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef0dab10","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/register.vue
// module id = 503
// module chunks = 1